
import { Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, useTheme, Divider } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { tokens } from "../theme";

const HelpModal = ({ open, onClose, title, items }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          bgcolor: colors.grey[900],
          backgroundImage: 'none',
          border: `1px solid ${colors.grey[800]}`,
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        }
      }}
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 3, 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: `1px solid ${colors.grey[800]}`,
        bgcolor: colors.grey[900]
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <HelpOutlineIcon sx={{ color: colors.secondary[500], fontSize: 28 }} />
          <Typography variant="h4" sx={{ color: colors.grey[100], fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: colors.grey[400],
            '&:hover': { color: colors.grey[100], bgcolor: 'rgba(255,255,255,0.05)' }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0 }}>
        {items.map((item, index) => (
          <Box 
            key={index} 
            sx={{ 
              p: 3, 
              borderBottom: index < items.length - 1 ? `1px solid ${colors.grey[800]}` : 'none',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.02)' },
              transition: 'background-color 0.2s'
            }}
          >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
               {/* Optional bullet or number can go here if distinct steps */}
               <Box sx={{ flex: 1 }}>
                <Typography variant="h5" sx={{ color: colors.secondary[400], fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                  {item.icon && <Box component="span" sx={{ display: 'flex', mr: 1 }}>{item.icon}</Box>}
                  {item.title}
                </Typography>
                <Typography variant="body1" sx={{ color: colors.grey[300], lineHeight: 1.6 }}>
                  {item.description}
                </Typography>
               </Box>
            </Box>
          </Box>
        ))}
      </DialogContent>
      
      <DialogActions sx={{ p: 2, borderTop: `1px solid ${colors.grey[800]}`, bgcolor: colors.grey[900] }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="secondary" 
          sx={{ px: 4, fontWeight: 600 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpModal;
